
import React from 'react';
import { Control } from 'react-hook-form';
import SharedFormTermsField from '@/components/terms/FormTermsField';
import { FormValues } from './signupFormSchema';

interface FormTermsFieldProps {
  control: Control<FormValues>;
}

const FormTermsField = ({ control }: FormTermsFieldProps) => {
  return (
    <SharedFormTermsField 
      control={control}
      textColor="text-white"
      checkboxClass="border-white data-[state=checked]:bg-synthreo-blue-medium data-[state=checked]:text-white"
      linkClass="text-synthreo-blue-medium hover:underline"
    />
  );
};

export default FormTermsField;
